export enum MFATypes {
    App,
    SMS,
    Email
}
